import { motion } from "framer-motion"

export default function PageBanner({
  title,
  subtitle,
  image,
}) {
  return (
    <section
      className="relative min-h-[300px] md:min-h-[380px] flex items-center justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
  {/*  
  <img
          src={image}
          alt={title}
          className="w-full h-full object-cover"
          loading="eager"
        />
        */}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/55" />

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 max-w-4xl mx-auto px-6 text-center"
      >
        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
          {title}
        </h1>

        {subtitle && (
          <p className="mt-5 text-gray-200 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
      </motion.div>
    </section>
  )
}